const apps = [
  {
    name: `People`,
    route: `/people`,
    key: `people`,
    nav: true,
    beta: true,
    productCode: `people`,
    icon: require(`./assets/people.svg`)
  },
  {
    name: `Giving`,
    route: `/giving`,
    key: `giving`,
    nav: true,
    beta: true,
    productCode: `giving`,
    icon: require(`./assets/giving.svg`)
  },
  {
    name: `Messaging`,
    route: `/messaging`,
    key: `messaging`,
    nav: true,
    beta: true,
    productCode: `people`,
    icon: require(`./assets/messaging.svg`)
  },
  {
    name: `Events`,
    route: `/events`,
    key: `events`,
    nav: true,
    icon: require(`./assets/events.svg`)
  },
  {
    name: `Apps`,
    key: `apps`,
    nav: true,
    icon: require(`./assets/apps.svg`),
    route: `/apps`
  },
  {
    name: `Breeze`,
    route: `/breeze`,
    key: `breeze`,
    nav: true,
    productCode: `breeze`,
    icon: require(`./assets/breeze.svg`)
  },
  {
    name: `Sites`,
    route: `/sites`,
    key: `websites`,
    nav: true,
    productCode: `websites`,
    icon: require(`./assets/sites.svg`)
  },
  {
    name: `ChMS`,
    route: `/chms`,
    key: `chms`,
    nav: true,
    icon: require(`./assets/chms.svg`)
  },
  {
    name: `Media`,
    route: `/media`,
    key: `media`,
    nav: true,
    beta: true,
    icon: require(`./assets/media.svg`)
  },
  {
    name: `Pay`,
    route: `/pay`,
    key: `pay`,
    nav: true,
    beta: true,
    icon: require(`./assets/pay.svg`)
  }
]

export default apps
